import { combineReducers } from 'redux';
import authReducer from './auth.slice';
import cartSlice from './cart.slice';
import catalogSlice from './catalog.slice';
import orderSlice from './order.slice';
import paymentSlice from './payment.slice';
import purchaseSlice from './purchase.slice';
import searchReducer from './search.slice';
import settingSlice from './setting.slice';
import userReducer from './user.slice';

const RootReducer = combineReducers({
  auth: authReducer,
  search: searchReducer,
  user: userReducer,
  catalog: catalogSlice,
  cart: cartSlice,
  purchase: purchaseSlice,
  order: orderSlice,
  payment: paymentSlice,
  setting: settingSlice,
});

export default RootReducer;
